import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrExperienceCategory.ts
var t = () => e("experienceCategory");
//#endregion
export { t as useTrExperienceCategory };
